export const BOOKING_PARAMS = 'BOOKING_PARAMS';
